// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2i3GY","open":"open___1Chyt","h":"h___27KW6","sans":"sans___2WEo9","noMargin":"noMargin___1E2GN","center":"center___2-LJ5","ellipsis":"ellipsis___200Wy"};